// NPM
/* Load npm scripts here */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// VENDOR
/* Load vendor modules here */
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';

// HELPERS
/* Load helpers here */
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// HELPERS
/* Load helpers here */

// COMPONENTS
/* Load components here */
import { InlineWattageCalculator } from 'components/radiator-watt-calculator/radiator-watt-calculator';
import { ContactFormB2B } from 'components/form/form-collection/contact-b2b'; // for b2b page (id 3)

// PAGE
/* load page specific scripts */

defaultBundle();

function removeGoogleAdParams() {
    const url = new URL(window.location.href);

    // List of tracking params to remove
    const paramsToRemove = ['gclid', '_gl'];

    // Remove each param
    paramsToRemove.forEach((param) => url.searchParams.delete(param));

    // Only update the URL if it actually changed
    if (window.location.href !== url.href) {
        window.history.replaceState({}, document.title, url.toString());
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.head.dataset.mktPageId === '"3899"') {
        removeGoogleAdParams();
    }
});

// Init category link block swiper
const seoSlider = document.querySelector('.product-swiper');
if (seoSlider) {
    const swiperConfig = withFocusManagement({
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 16,
        slidesPerView: 1.5,
        breakpoints: {
            380: {
                slidesPerView: 2.5
            },
            769: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 4
            },
            1200: {
                slidesPerView: 5
            },
            1550: {
                slidesPerView: 6
            }
        }
    });

    // Create new Swiper
    const productSwiper = new Swiper(seoSlider, swiperConfig);

    // Get GTM data attributes
    const gtmCategory = seoSlider.dataset.gtmCategory;
    const gtmAction = seoSlider.dataset.gtmAction;
    const gtmLabel = seoSlider.dataset.gtmLabel;

    if (gtmCategory && gtmAction && gtmLabel) {
        // TrackEvent on slideChange
        productSwiper.on('slideChange', function () {
            trackEvent(gtmCategory, gtmAction, gtmLabel);
        });
    }
}

// Wattage calculator
InlineWattageCalculator.init();
// B2B contact form
ContactFormB2B.init();
